export default __webpack_public_path__ + "static/media/home_shop_card.bcd35785.jpg";